var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UploadFiles',{ref:"uploader",staticClass:"hidden",attrs:{"options":{
      limit: 1,
      accept: ['image/jpeg', 'image/png', 'video/mp4'],
      multiple: false,
    }},on:{"change":_vm.onFilePicked},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}}),(_vm.$is_GD)?_c('el-button',{class:[
      'w-[40px] h-[40px] flex justify-center items-center',
      { 'is-disabled opacity-50': !_vm.canUploadReplaceAndDeleteFile(_vm.creative?.status) },
    ],attrs:{"disabled":!_vm.canUploadReplaceAndDeleteFile(_vm.creative?.status),"type":"text"},on:{"click":_vm.triggerBrowse}},[_c('svg',{staticClass:"text-gray",attrs:{"width":"12","height":"12","fill":"none"}},[_c('use',{attrs:{"xlink:href":"#replace-img"}})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }